<div class="advert-attributes-editor-container">
  @for (attrGroup of this.advertForm.controls.attributes?.controls; let i = $index; track i) {
    <div class="advert-attributes-editor-item">
      @if (attributes[i].validation?.allow_multiple_values) {
        <div class="advert-attributes-editor-checkbox-list-container">
          <div class="advert-attributes-editor-checkbox-list-label"
               [ngClass]="{ 'text-danger': attrGroup.touched && attrGroup.invalid }">
            {{ attributes[i].label }}
            @if (attributes[i].validation?.required) {
              *
            }
          </div>
          <div class="advert-attributes-editor-checkbox-list">
            @for (value of attributes[i].values; track value.code) {
              <app-checkbox [checked]="attrGroup.controls.values!.value!.includes(value.code)"
                            (change)="onCheck(attrGroup, value.code, $event)">
                {{ value.label }}
              </app-checkbox>
            }
          </div>
        </div>
      }

      @if (!attributes[i].validation?.allow_multiple_values && attributes[i].values?.length) {
        @if (attributes[i].values!.length > 2) {
          <app-dropdown [formControl]="attrGroup.controls.value!"
                        [items]="attributes[i].values!"
                        bindValue="code"
                        bindLabel="label"
                        bindLabelOption="label"
                        [closeOnSelect]="true"
                        [searchable]="true"
                        [clearable]="!attributes[i].validation?.required"
                        [label]="attributes[i].label"
                        [isRequired]="!!attributes[i].validation?.required"
                        [error]="attrGroup.invalid && attrGroup.touched"
                        [isAppendToBody]="false"
                        (focusout)="attrGroup.markAsTouched()" />
        }

        @if (attributes[i].values!.length <= 2) {
          <app-button-toggle-group [control]="attrGroup.controls.value!"
                                   [values]="attributes[i].values!"
                                   bindValue="code"
                                   [label]="attributes[i].label"
                                   [isTranslate]="false"
                                   [isRequired]="!!attributes[i].validation?.required"
                                   [isError]="attrGroup.invalid && attrGroup.touched"
                                   (focusout)="attrGroup.markAsTouched()" />
        }
      }

      @if (!attributes[i].values?.length) {
        <app-text-field [formControl]="attrGroup.controls.value!"
                        [label]="attributes[i].label"
                        [placeholder]="attributes[i].unit || ''"
                        [mask]="attributes[i].validation?.numeric ? 'separator.2' : ''"
                        [required]="!!attributes[i].validation?.required"
                        [error]="attrGroup.invalid && attrGroup.touched"
                        (focusout)="attrGroup.markAsTouched()" />
      }

      @if (attrGroup.touched && attrGroup.invalid) {
        <mat-hint class="advert-attributes-editor-error text-danger">
          @if (attrGroup.controls.value?.errors?.['required'] || attrGroup.controls.values?.errors?.['required']) {
            {{ 'field_cannot_be_empty' | translate }}
          }
          @if (attrGroup.controls.value?.errors?.['max']) {
            {{ 'min_value' | translate }} {{ attributes[i].validation?.min }}
          }
          @if (attrGroup.controls.value?.errors?.['max']) {
            {{ 'max_value' | translate }} {{ attributes[i].validation?.max }}
          }
        </mat-hint>
      }
    </div>
  }
</div>
